import { TopBaseTheme } from '@talentinc/gatsby-theme-ecom/themes/top'

export const TopResumeTheme = TopBaseTheme

export default TopResumeTheme
